import { render, staticRenderFns } from "./DomainsDonate.vue?vue&type=template&id=363809d8&scoped=true"
import script from "./DomainsDonate.vue?vue&type=script&lang=js"
export * from "./DomainsDonate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363809d8",
  null
  
)

export default component.exports